import React from 'react';
var Tableau = function (_a) {
    var caption = _a.caption, children = _a.children, avecBordure = _a.avecBordure, sansScroll = _a.sansScroll, tailleFixe = _a.tailleFixe, noCaption = _a.noCaption, captionEnBas = _a.captionEnBas, couleur = _a.couleur;
    var classTableau = 'fr-table';
    if (avecBordure) {
        classTableau += ' fr-table--bordered';
    }
    if (sansScroll) {
        classTableau += ' fr-table--no-scroll';
    }
    if (tailleFixe) {
        classTableau += ' fr-table--layout-fixed';
    }
    if (noCaption) {
        classTableau += ' fr-table--no-caption';
    }
    if (captionEnBas) {
        classTableau += ' fr-table--caption-bottom';
    }
    if (couleur) {
        classTableau += ' fr-table--' + couleur;
    }
    return (React.createElement("div", { className: classTableau },
        React.createElement("table", null,
            React.createElement("caption", null, caption),
            children)));
};
Tableau.defaultProps = {
    avecBordure: false,
    sansScroll: false,
    tailleFixe: false,
    noCaption: false,
    captionEnBas: false,
};
export default Tableau;
